import React, {useEffect} from 'react';

import LoadBar from '../../components/LoadBar';
import MainContent from '../../components/MainContent';
import UserBar from '../../components/UserBar';
import {analyticsService} from '../../services/analytics';
import {pushViewTagManager} from '../../services/tagManager';
import {getAcceptWarnings, setAcceptWarnings} from '../../services/warnings';
import {DotTyping} from '../../shared/components/DotTyping';

import {
  SEGREGATION_TERMS,
  SEGREGATION_TOOLTIP
} from './../../constants/parameterization';
import {useGetParameterization} from './../../hooks/useGetParameterization';

export const Chat = () => {
  useGetParameterization(SEGREGATION_TERMS);
  useGetParameterization(SEGREGATION_TOOLTIP);

  useEffect(() => {
    if (getAcceptWarnings() !== 'yes') {
      window.location.assign('/');
    } else {
      setAcceptWarnings('not');
      analyticsService.trackPageView('Chat');
      pushViewTagManager({
        appName: 'credenciamento-web-chatbot',
        screenName: 'credenciamento:chatbot',
        sectionApp: 'credenciamento-chatbot'
      });
    }

    const handleBeforeUnload = (e) => {
      const isAccreditationComplete = sessionStorage.getItem(
        'accreditation_completed'
      );
      if (!isAccreditationComplete) {
        analyticsService.trackAccreditationAbandoned();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  return (
    <>
      <LoadBar />
      <MainContent />
      <DotTyping />
      <UserBar />
    </>
  );
};
